import { Component, OnInit, } from '@angular/core';


@Component({
  selector: 'app-payment-failure',
  templateUrl: './payment-failure.component.html',
  styleUrls: ['./payment-failure.component.css']
})
export class PaymentFailureComponent implements OnInit {
 
  constructor() {
  }

  ngOnInit() {
   
  }

}




// WEBPACK FOOTER //
// ./src/app/registration/payment-failure/payment-failure.component.ts